"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Svg(_ref) {
  var styles = _ref.styles;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "62",
    height: "62",
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: styles
  }, /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "62",
    height: "62"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "31",
    cy: "31",
    r: "31",
    fill: "#2F61E0"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    opacity: "0.2",
    cx: "31",
    cy: "31",
    r: "31",
    fill: "#36B37E"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "-6",
    y: "31",
    width: "42",
    height: "50",
    rx: "6",
    fill: "#36B37E"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "33",
    y: "-40",
    width: "42",
    height: "50",
    rx: "6",
    fill: "#36B37E"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23 -5V14.5V19.75M48.5 21V27.5V38M48.5 62.5V38M48.5 38H76M23 19.75H-24M23 19.75H66",
    stroke: "#0A7346",
    strokeWidth: "3"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "33",
    cy: "35",
    r: "10",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "32",
    y: "30",
    width: "2",
    height: "10",
    rx: "1",
    fill: "#0A7346"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "28",
    y: "36",
    width: "2",
    height: "10",
    rx: "1",
    transform: "rotate(-90 28 36)",
    fill: "#0A7346"
  })));
}

var _default = Svg;
exports.default = _default;